import { convertDateToTimeZone, prepareTime } from 'infrastructure/functions';
import {
  addDays,
  setHours,
  setMinutes,
  setSeconds,
  startOfDay,
} from 'date-fns';
import { between } from 'infrastructure/functions/between';
import { Timezones } from 'infrastructure/enums';

import type { Nullable } from 'infrastructure/types';

export const isInDoNotCallWindow = (
  startTime: string,
  endTime: string,
  pTZ: Nullable<string> = Timezones['America/Chicago'],
): boolean => {
  const parsedStartTime = prepareTime(startTime);
  const parsedEndTime = prepareTime(endTime);

  if (!parsedStartTime || !parsedEndTime) {
    return false;
  }

  const patientNow = pTZ ? convertDateToTimeZone(new Date(), pTZ) : new Date();

  const [sH, sM] = parsedStartTime.split(':').map(Number);
  const [eH, eM] = parsedEndTime.split(':').map(Number);

  const todayStart = startOfDay(patientNow);

  const startToday = setHours(setMinutes(setSeconds(todayStart, 0), sM), sH);

  const endToday = setHours(setMinutes(setSeconds(todayStart, 0), eM), eH);

  let windowStart: Date;
  let windowEnd: Date;

  if (startToday > endToday) {
    if (patientNow < endToday) {
      windowStart = addDays(startToday, -1);
      windowEnd = endToday;
    } else {
      windowStart = startToday;
      windowEnd = addDays(endToday, 1);
    }
  } else {
    windowStart = startToday;
    windowEnd = endToday;
  }

  return between(
    patientNow.getTime(),
    windowStart.getTime(),
    windowEnd.getTime(),
  );
};
